<p>Job boards search history for
	<span class="emerald mr-2">{{jobTitle}}</span>
	<span *ngIf="clientOrBuName !== ''">at
		<span class="emerald ml-2">{{clientOrBuName}}</span>
	</span>
</p>

<accordion [closeOthers]="true" *ngIf="searchHistoryContainer?.searchHistoryExistFlag"
	infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
	(scrolled)="searchHistoryContainer.getNext()"
	[infiniteScrollDisabled]="searchHistoryContainer.busy || searchHistoryContainer.disableInfiniteScroll">
	<accordion-group *ngFor="let searchDetail of searchHistoryContainer.searchHistory; let i = index" [isOpen]="isPanelOpen[i]">
		<div accordion-heading>
			<div style="font-size: small" [ngClass]="{'text-danger': searchDetail.searchStatus == 'failure'}">
				<b>{{searchDetail.noOfResumesPulled}}</b>
				Candidate Resumes Added on
				<span>{{searchDetail.requestedDate | fourDotFiveTimeStampFormatPipe}}</span>
				<i class="pull-right glyphicon" [ngClass]="{'glyphicon-chevron-down': isPanelOpen[i], 'glyphicon-chevron-right': !isPanelOpen[i]}"></i>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-3">
				<div class="col-xs-12" style="padding: 15px; padding-left: 30px;">
					<div class="row">
						<div class="col-xs-12 emerald">
							<h3 style="margin-top:0; border-bottom:0px">
								<strong>Job Boards</strong>
							</h3>
						</div>
						<div class="col-xs-12" style="padding-left: 20px">
							<p *ngFor="let jobBoard of searchDetail.jobBoards">{{jobBoard?.sourceType}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xs-9" style="border-left: 1px solid lightgray">
				<div class="col-xs-12" style="padding: 15px; padding-left: 30px;">
					<div class="row">
						<div class="col-xs-12 emerald">
							<h3 style="margin-top:0; border-bottom:0px">
								<strong>Search Filters</strong>
							</h3>
						</div>
						<div class="col-xs-12">
							<table class="table table-bordered">
								<tbody>
									<tr>
										<td>
											<div class="col-xs-6">
												Number of resumes to pull:
											</div>
											<div class="col-xs-6">
												<span>{{searchDetail.resumesToPullPerJobBoardCount}}</span>
											</div>
										</td>
										<td>
											<div class="col-xs-6">
												<i class="far fa-clock mr-1"></i>Recency:
											</div>
											<div class="col-xs-6">
												<span>{{searchDetail.recency}}</span>
												<span> days</span>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="col-xs-6">
												<i class="fa fa-map-marker-alt mr-1"></i>
												Location :
											</div>
											<div class="col-xs-6">
												<span *ngIf="searchDetail.location != null">{{searchDetail.location}}</span>
												<span *ngIf="searchDetail.location == null">
													Not Available
												</span>
											</div>
										</td>
										<td>
											<div class="col-xs-6">
												<i class="fa fa-map-pin mr-1"></i>Postcode:
											</div>
											<div class="col-xs-6">
												<span *ngIf="searchDetail.postcode !== null">{{searchDetail.postcode}}</span>
												<span *ngIf="searchDetail.postcode == null">Not Available</span>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="col-xs-6">
												<i class="fa fa-compass mr-1"></i>Radius:
											</div>
											<div class="col-xs-6">
												<span>{{searchDetail.radius}}</span>
												<span> miles</span>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</accordion-group>
</accordion>

<div class="row skeleton-container" *ngIf="searchHistoryContainer?.busy">
	<div class="col-xs-12" style="padding:15px">
		<div class="skeleton-paragraph skeleton-loading" style="width:60%; margin-bottom:10px"></div>
		<div class="skeleton-content skeleton-loading"></div>
	</div>
</div>

<div class="row animate-if" *ngIf="!searchHistoryContainer?.searchHistoryExistFlag">
    <div class="col-xs-12 no_history_found text-center">
        No Search History Found!
    </div>
</div>
